import { select } from '../helpers';

export default () => {
  const toggleSearchMobile = select('.header .open-search-mobile');
  const toggleSearch = select('.header .open-search');

  const openSearchMobile = () =>
    select('.header__logo .search-block-form').classList.toggle('opened');
  const openSearch = () =>
    select('.region-primary-menu .search-block-form').classList.toggle('opened');

  toggleSearchMobile.addEventListener('click', openSearchMobile);
  toggleSearch.addEventListener('click', openSearch);
};
